// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_SSH_KEY_LIST = 'ssh-keys/SET_SSH_KEYS_LIST';
export const APPEND_SSH_KEY_LIST = 'ssh-keys/APPEND_SSH_KEY_LIST';
export const REMOVE_SSH_KEY_ITEM = 'ssh-keys/REMOVE_SSH_KEY_ITEM';
export const ADD_SSH_KEY_ITEM = 'ssh-keys/ADD_SSH_KEY_ITEM';
export const SET_SSH_KEY_IS_DELETING = 'ssh-keys/SET_SSH_KEY_IS_DELETING';
